<template>
  <div>

    <div class="sm:flex items-center space-x-2">
      <div class="mb-4 flex-shrink-0 sm:mb-0 ml-3 sm:ml-0 sm:mr-4">
        <p class="text-sm">Logo-Upload</p>
        <p class="text-xs text-gray-400 mt-2">png,jpg,gif,max 1MB</p>
      </div>
      <div class="flex-1">
        <form @submit.prevent="submitForm">
          <div>
            <input type="file" @change="handleFileChange" :disabled="form.processing" accept=".jpg,.jpeg,.png,.gif"
              class="w-full text-gray-500 font-medium text-sm bg-gray-200 file:cursor-pointer cursor-pointer file:border-0 file:py-1 file:px-2 file:mr-4 file:bg-gray-500 file:hover:bg-markencode-blue file:text-white rounded-md outline-none focus:outline-none" />
          </div>



          <div class="mt-0 flex items-center justify-between space-x-1">

            <!-- logo position: start -->
            <div class="flex items-center justify-start space-x-1">

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-none">
                <input type="radio" v-model="form.logo_position" name="logo_position" value="left" class="sr-only">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue"
                  :class="form.logo_position == 'left' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
                </svg>
              </label>

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-nonew-5 h-5">
                <input type="radio" v-model="form.logo_position" name="logo_position" value="center" class="sr-only">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue"
                  :class="form.logo_position == 'center' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </label>

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-nonew-5 h-5">
                <input type="radio" v-model="form.logo_position" name="logo_position" value="right" class="sr-only">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue"
                  :class="form.logo_position == 'right' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25" />
                </svg>
              </label>
            </div>
            <!-- logo position: end -->


            <!-- logo size: start -->
            <div class="flex items-center justify-start">

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-none mt-1">
                <input type="radio" v-model="form.logo_size" name="logo_size" value="s" class="sr-only">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-4 h-4 hover:text-markencode-blue"
                  :class="form.logo_size == 's' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                </svg>
              </label>

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-nonew-5 h-5">
                <input type="radio" v-model="form.logo_size" name="logo_size" value="m" class="sr-only">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue"
                  :class="form.logo_size == 'm' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                </svg>
              </label>

              <label
                class="flex cursor-pointer items-center justify-center rounded-md px-1 py-1 text-sm font-semibold uppercase focus:outline-nonew-5 h-5">
                <input type="radio" v-model="form.logo_size" name="logo_size" value="l" class="sr-only">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-6 h-6 hover:text-markencode-blue"
                  :class="form.logo_size == 'l' ? 'text-markencode-blue' : 'text-gray-400'">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                </svg>
              </label>
            </div>
            <!-- logo size: end -->

          </div>

        </form>
      </div>
      <div v-if="progress !== null"
        class="w-1/12 shrink-0 inline-flex items-center rounded-full bg-markencode-blue px-2 py-1 text-xs font-medium text-white ring-1 ring-inset ring-red-600/10">
        {{ progress }}%
      </div>

      <div v-else class="w-1/12"></div>

    </div>

    <div v-if="session.session_logo_url" class="mt-3 px-3 sm:px-0 flex items-center">
      <div class="flex-1">
        <img :src="sessionLogoUrl" class="w-32">
      </div>
      <div class="">
        <svg @click="deleteSessionLogo" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor"
          class="w-4 h-4 text-gray-400 hover:text-markencode-red cursor-pointer">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
        </svg>

      </div>
    </div>

  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    session: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        logo: null,
        logo_position: this.session.logo_position || 'center',
        logo_size: this.session.logo_size || 'm',
      }),
      progress: null,
    };
  },

  watch: {
    form: {
      handler: function (settings) {
        this.$emit('logoSettingsUpdated', {
          position: settings.logo_position,
          size: settings.logo_size,
        });
      },
      deep: true
    },
  },

  // mounted() {
  //   console.log(this.route('control-panel.session-logo.upload', {
  //         sessionUuid: this.session.uuid,
  //       }));
  // },

  methods: {
    handleFileChange(event) {
      this.form.logo = event.target.files[0];

      this.submitForm();
    },

    submitForm() {
      const formData = new FormData();
      formData.append('logo', this.form.logo);

      this.$inertia.post(
        this.route('control-panel.session-logo.upload', {
          sessionUuid: this.session.uuid,
        }),
        formData,
        {
          preserveScroll: true,
          onProgress: (event) => {
            this.progress = Math.round((event.loaded / event.total) * 100);
          },
          onSuccess: () => {
            this.form.reset();
            this.progress = null;
          },
          onError: () => {
            this.progress = null;
          },
        });
    },

    deleteSessionLogo() {
      this.$inertia.post(
        this.route('control-panel.session-logo.delete', {
          sessionUuid: this.session.uuid,
        }),
        {},
        {
          preserveScroll: true,
        }
      );
    },
  },

  computed: {
    sessionLogoUrl() {
      return `${this.session.session_logo_url}?${uuidv4()}`;
    },
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
